import { UPDATE_PROPERTY } from '../actions/properties'

export default (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PROPERTY:
      return {
        ...state,
        [action.productId]: {
          ...state[action.productId],
          ...action.properties
        }
      }
    default:
      return state
  }
}
